export class TypeAbonnement {
  static EARLYBIRD = "earlybird";
  static REGULAR = "regular";
  static STANDARD = "standard";
  static TRIAL = "trial";
  static AUCUN = "aucun";
  static CUSTOM = "custom";
}
